const formatAvailability = (availableFrom, vacantString) => {
	if (!availableFrom) return vacantString;
	const alreadyVacant = new Date().getTime() > new Date(availableFrom).getTime();
	const reversed = availableFrom.split('-').reverse().join('-');
	return alreadyVacant ? vacantString : `${reversed}`;
};	

export default formatAvailability;